
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","stroke":"currentcolor","width":"20","height":"20","color":"#4C76E0","fill":"currentcolor","stroke-width":"1.5"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill-rule":"evenodd","stroke-linecap":"round","stroke-linejoin":"round","fill":"none"}},[_c('path',{attrs:{"d":"M20.75 20.128c0 .69-.56 1.25-1.25 1.25h-15c-.69 0-1.25-.56-1.25-1.25V3.878c0-.69.56-1.25 1.25-1.25h12.538c.326 0 .64.127.873.355l2.462 2.402c.241.235.377.558.377.895v13.848h0z"}}),_c('path',{attrs:{"d":"M10.75 8.877h-.625a1.174 1.174 0 00-1.25 1.079v1.039c-.01.378-.223.72-.557.897L7 12.65l1.318.758c.334.176.546.519.557.896v1.04c.05.641.608 1.122 1.25 1.078h.625m2.5-7.545h.625c.642-.044 1.2.437 1.25 1.079v1.039c.01.378.223.72.557.897L17 12.65l-1.318.758a1.047 1.047 0 00-.557.896v1.04a1.173 1.173 0 01-1.25 1.078h-.625"}})])])
          )
        }
      }
    